<div class="card border-0 shadow-sm m-0 border-0">
    <div class="d-flex justify-content-between align-items-center p-2 bg-light rounded-top">
        <div class="d-flex gap-2">
            <span class="badge px-3 py-2 clickable d-flex align-items-center" [ngClass]="{'bg-primary text-white': activeTab === 'announcements', 'bg-white text-dark border': activeTab !== 'announcements'}" (click)="setActiveTab('announcements')">
                <i class="fa fa-bullhorn me-1"></i>Announcements
                <span class="badge bg-warning text-dark ms-2" *ngIf="filterStatus === 'UnRead'">
                    {{getUnReadAnnouncementsCount()}}
                </span>
                <span class="badge bg-warning text-dark ms-2" *ngIf="filterStatus === 'Read'">
                    {{getReadAnnouncementsCount()}}
                </span>
            </span>
            <span class="badge px-3 py-2 clickable d-flex align-items-center" [ngClass]="{'bg-primary text-white': activeTab === 'notifications', 'bg-white text-dark border': activeTab !== 'notifications'}" (click)="setActiveTab('notifications')">
                <i class="fa fa-bell me-1"></i>Notifications
                <span class="badge bg-warning text-dark ms-2" *ngIf="filterStatus === 'UnRead'">
                    {{getUnReadNotificationsCount()}}
                </span>
                <span class="badge bg-warning text-dark ms-2" *ngIf="filterStatus === 'Read'">
                    {{getReadNotificationsCount()}}
                </span>
            </span>
        </div>
        <div class="d-flex gap-1">
            <span class="badge bg-white border clickable text-dark" [ngClass]="{'border-primary': filterStatus === 'UnRead'}" (click)="setFilterStatus('UnRead')">
                <i class="fa fa-eye-slash me-1"></i>Unread
            </span>
            <span class="badge bg-white border clickable text-dark" [ngClass]="{'border-primary': filterStatus === 'Read'}" (click)="setFilterStatus('Read')">
                <i class="fa fa-check-double text-primary me-1"></i>Read
            </span>
            <span class="badge bg-white border clickable text-dark" (click)="clearAll()">
                <i class="fa fa-check-circle me-1 text-success"></i>Mark All as Read
            </span>
        </div>
    </div>

    <!-- Announcements -->
    <div *ngIf="activeTab === 'announcements'">
        <ul class="list-group list-group-flush">
            <li class="list-group-item py-1" *ngFor="let announcement of getFilteredAnnouncements(); let i = index">
                <div class="d-flex justify-content-between">
                    <div class="d-flex clickable" (click)="openNotification(announcement)">
                        <div class="d-flex flex-column justify-content-center">
                            <i class="fa-duotone fa-bell shadow-sm align-self-center notification-icon"></i>
                        </div>
                        <div class="m-3">
                            <b>
                                {{announcement.announcementHeader}}
                            </b>
                        </div>
                    </div>
                    <div class="d-flex flex-column">
                        <div class="ms-auto mb-1 d-flex">
                            <span class="badge bg-warning clickable" (click)="openNotification(announcement)">
                                <i class="fa-regular fa-up-right-and-down-left-from-center text-dark"></i>
                            </span>
                            <span class="badge bg-warning ms-2 clickable" (click)="deleteNotification(i)">
                                <i class="fa fa-trash-alt text-dark clickable"></i>
                            </span>
                        </div>

                        <div>
                            <p class="text-muted mb-0 float-end">
                                <small>
                                    <small>
                                        <i class="fas fa-clock"></i>
                                        <span class="text-muted">
                                            {{announcement.announcementUpdatedDate | date: 'MM/dd/yyyy h:mm a' : '' : 'en-US'}} - {{announcement.announcementStatus}}
                                        </span>
                                    </small>
                                </small>
                            </p>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>

    <!-- Notifications -->
    <div *ngIf="activeTab === 'notifications'">
        <ul class="list-group list-group-flush">
            <li class="list-group-item py-1" *ngFor="let notification of getFilteredNotifications(); let i = index">
                <div class="d-flex justify-content-between">
                    <div class="d-flex clickable" (click)="openNotification(notification)">
                        <div class="d-flex flex-column justify-content-center">
                            <i class="fa-duotone fa-bell shadow-sm align-self-center notification-icon"></i>
                        </div>
                        <div class="m-3">
                            <b>
                                {{notification.pushNotificationHeader}}
                            </b>
                        </div>
                    </div>
                    <div class="d-flex flex-column">
                        <div class="ms-auto mb-1">
                            <span class="badge bg-warning clickable" (click)="openNotification(notification)">
                                <i class="fa-regular fa-up-right-and-down-left-from-center text-dark"></i>
                            </span>
                            <span class="badge bg-warning ms-2 clickable" (click)="deleteNotification(i)">
                                <i class="fa fa-trash-alt text-dark clickable"></i>
                            </span>
                            <!-- <i class="fa-regular fa-up-right-and-down-left-from-center p-2 mx-2 shadow-sm" style="border-radius: 4px;"></i>
                                <i class="fa fa-times text-danger clickable pb-2 p-2 shadow-sm"  style="border-radius: 4px;" (click)="deleteNotification(i)"></i> -->
                        </div>

                        <div>
                            <p class="text-muted mb-0 float-end">
                                <small>
                                    <small>
                                        <i class="fas fa-clock"></i>
                                        <span class="text-muted">
                                            {{notification.pushNotificationUpdatedDate | date: 'MM/dd/yyyy h:mm a' : '' : 'en-US'}}
                                        </span>
                                    </small>
                                </small>
                            </p>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>

